var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInsurance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "96px",
    height: "96px",
    viewBox: "0 0 96 96",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Icons_Umbrella",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 10 50 7.5C50 6.4 49.1 5.5 48 5.5 46.9 5.5 46 6.4 46 7.5L46 10C24.8 11 8 26.7 8 46 8 46.6 8.4 47 9 47 9.6 47 10 46.6 10 46 10 40 15.4 35.2 22 35.2 28.6 35.2 34 40 34 46 34 46.6 34.4 47 35 47 35.6 47 36 46.6 36 46 36 40.7 40.3 36.2 46 35.4L46 76 45 76 45 80.5C45 81.6 44.1 82.5 43 82.5 41.9 82.5 41 81.6 41 80.5 41 78.8 39.7 77.5 38 77.5 36.3 77.5 35 78.8 35 80.5 35 84.9 38.6 88.5 43 88.5 47.4 88.5 51 84.9 51 80.5L51 76 50 76 50 35.4C55.7 36.3 60 40.7 60 46 60 46.6 60.4 47 61 47 61.6 47 62 46.6 62 46 62 40 67.4 35.2 74 35.2 80.6 35.2 86 40 86 46 86 46.6 86.4 47 87 47 87.6 47 88 46.6 88 46 88 26.7 71.2 11 50 10Z",
    stroke: "#FFFFFF",
    strokeWidth: 0.999939,
    fill: "#FFFFFF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsurance);
export default __webpack_public_path__ + "static/media/insurance.95b3e566f745b14c42fcb362d3fe3cb5.svg";
export { ForwardRef as ReactComponent };